import { Button } from '@finbeat/react-toolkit';
import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { loanWriteOff } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { Trans } from 'react-i18next';
import { useMutation } from 'react-query';

const WriteOffButton = ({
    isLoanWriteOffPossible,
    id,
}: {
    isLoanWriteOffPossible: boolean;
    id: string | number | undefined;
}) => {
    const api = useApi();
    const writeOffMutation = useMutation('writeOffMutation', () => loanWriteOff(api, id));

    return isLoanWriteOffPossible ? (
        <div>
            <Button type="button" className="popover-btn" onClick={() => writeOffMutation.mutate()}>
                <FontAwesomeIcon icon={faEraser} className={`text-danger order-action-btn__icon`} />
                <span>
                    <Trans i18nKey={'BackOfficeWriteOff'} />
                </span>
            </Button>
        </div>
    ) : (
        <></>
    );
};

export default WriteOffButton;
